var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.variant,attrs:{"to":_vm.url,"disabled":_vm.disabled},on:{"click":_vm.onclick}},[(_vm.icon)?_c('img',{staticClass:"img",attrs:{"src":_vm.icon}}):_vm._e(),_vm._v(_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }